import { render } from "./UnterkunftsTyp.vue?vue&type=template&id=1285d105"
import script from "./UnterkunftsTyp.vue?vue&type=script&lang=js"
export * from "./UnterkunftsTyp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__